import { render, staticRenderFns } from "./MultiColumnarContent.vue?vue&type=template&id=38cd6228"
import script from "./MultiColumnarContent.vue?vue&type=script&lang=js"
export * from "./MultiColumnarContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports